import type { MainCommandMentionCandidate } from '../lib/main-command-mentions';

export function MainCommandMentionMenu({
  suggestions,
  activeIndex,
  onChoose,
}: {
  readonly suggestions: readonly MainCommandMentionCandidate[];
  readonly activeIndex: number;
  readonly onChoose: (candidate: MainCommandMentionCandidate) => void;
}) {
  if (suggestions.length === 0) return null;
  return (
    <div className="main-command-mention-menu" role="listbox" aria-label="Main Command recipients">
      {suggestions.map((candidate, index) => (
        <button
          key={candidate.key}
          type="button"
          role="option"
          aria-selected={index === activeIndex}
          className={index === activeIndex ? 'main-command-mention-option active' : 'main-command-mention-option'}
          data-recipient-kind={candidate.kind}
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => onChoose(candidate)}
        >
          <span>
            <strong>{candidate.label}</strong>
            <small>{candidate.detail}</small>
          </span>
          <span className={candidate.available ? 'mention-availability available' : 'mention-availability unavailable'}>
            {candidate.available ? 'Available' : 'Unavailable'}
          </span>
        </button>
      ))}
    </div>
  );
}
